import { render } from "./ViewHome.vue?vue&type=template&id=ae5afdca&scoped=true"
import script from "./ViewHome.vue?vue&type=script&lang=js"
export * from "./ViewHome.vue?vue&type=script&lang=js"

import "./ViewHome.vue?vue&type=style&index=0&id=ae5afdca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae5afdca"]])

export default __exports__